import React from 'react'

import { Button, Grid, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { primaryColor } from '../../utils/colors'

interface SomethingWentWrongProps {
    flagStaticErrorPage?: boolean
} 

const SomethingWentWrong: React.FC<SomethingWentWrongProps> = (props) => {

    const { flagStaticErrorPage } = props;

    const navigate = useNavigate()

    return (
        <>
            <Grid container className='ww-pnf-main-container'>
                <Grid item xs={12}>
                    <Grid container>
                        <Grid item xs={12} className='ww-pnf-text-item'>
                            <Typography component='span' className='ww-pnf-text'>Something went wrong!</Typography>
                        </Grid>
                        <Grid item xs={12} className='ww-pnf-subtext-item'>
                            <Grid container sx={{ justifyContent: "center" }}>
                                <Grid item xs={2.4}>
                                    <Typography component='span' className='ww-pnf-subtext-text'>
                                        Some error occurred, please try again!
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item className='ww-pnf-home-page-btn'>
                            <Button
                                variant='contained'
                                fullWidth
                                size='large'
                                sx={{
                                    color: "white",
                                    textTransform: "none",
                                    background: primaryColor,
                                    borderRadius: "5px",
                                    fontWeight: "500",
                                    padding: "12px 25px !important",
                                    '&.MuiButton-root:hover': { bgcolor: primaryColor },
                                    boxShadow: "rgba(17, 12, 46, 0.15) 0px 48px 100px 0px",
                                    fontSize: "17px",
                                }}
                                onClick={() => { 
                                    if(!flagStaticErrorPage){
                                        navigate('/dashboard');
                                    } else {
                                        window.location.reload();
                                    }
                                }}
                            >
                                {`${!flagStaticErrorPage ? 'Back to homepage' : 'Try Again'}`}
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default SomethingWentWrong